import { useMediaQuery } from "@mui/material";
import { useTheme } from "../useTheme";

export const useResponsiveBelowXs = () => {
  const theme = useTheme();
  return useMediaQuery(
    `@media (max-width:${theme.breakpoints.values.xs - 1}px)`
  );
};

export const useResponsiveBelowSm = () => {
  const theme = useTheme();
  return useMediaQuery(
    `@media (max-width:${theme.breakpoints.values.sm - 1}px)`
  );
};

export const useResponsiveBelowMd = () => {
  const theme = useTheme();
  return useMediaQuery(
    `@media (max-width:${theme.breakpoints.values.md - 1}px)`
  );
};

export const useResponsiveBelowLg = () => {
  const theme = useTheme();
  return useMediaQuery(
    `@media (max-width:${theme.breakpoints.values.lg - 1}px)`
  );
};

export const useResponsiveBelowXl = () => {
  const theme = useTheme();
  return useMediaQuery(
    `@media (max-width:${theme.breakpoints.values.xl - 1}px)`
  );
};
